import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/arithmeticquadrature.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 35, 2, 1 Bl. 280<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: spring 1682 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (187k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Arithmetic Quadrature</title>
            <meta name="description" content="An English translation of ARITHMETIC QUADRATURE by Gottfried Wilhelm Leibniz, from spring 1682 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ARITHMETIC QUADRATURE</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>This short piece, in which Leibniz offers a title and outline for a longer work on his arithmetic quadrature, was written on one side of a thin strip of paper torn from a larger sheet. The paper bears no watermark, but the piece must have been written after Michelangelo Ricci was created Cardinal on 1 September 1681, an event Leibniz states had happened &quot;recently&quot;. The piece was probably written shortly after the publication of Leibniz's article &quot;De vera proportione circuli ad quadratum circumscriptum in numeris rationalibus ... expressa&quot; [On the True Proportion of The Circle to The Circumscribed Square, Expressed in Rational Numbers] in the February 1682 issue of the journal <var>Acta eruditorum</var>, as he alludes to one of the figures from this article.</small><br /><br /><br />
                  [<b>LH 35, 2, 1 Bl. 280</b>]<br /><br />
                <center>Gottfried Wilhelm Leibniz's Arithmetic Quadrature<br />
Or,<br />
On the True Proportion of the Circle to the Square on its Diameter, expressed and demonstrated in rational numbers by a very simple series<br />
Prefixed is <var>Exercitatio de maxima et minimis</var> by Michelangelo Ricci,<a name="1" href="#note1"><sup>1</sup></a> recently made Most Eminent Cardinal of the Holy Roman Church,<a name="2" href="#note2"><sup>2</sup></a> and some other things previously demonstrated by other geometers, which are employed in the present demonstration.</center><br />
From Ricci's work <var>On Maxima and Minima</var>, or <var>On the Property of Tangents</var>, I shall demonstrate the quadratures of the paraboloid and hyperboloid; from this I shall demonstrate my arithmetical quadrature. I shall also prefix Huygens' quadrature of the cissoid excerpted from Wallis's book <var>On Motion</var>,<a name="3" href="#note3"><sup>3</sup></a> because from that I can demonstrate the dimension of my rational curve commensurable with the circle. I shall also demonstrate that the circle is incommensurable with the square on its diameter, for since no inscribed or circumscribed polygon made by subdivision of a quadrant is commensurable with the square, neither therefore will the circle be. Yet the inference, strictly speaking, is not sufficiently manifest. The difference between any inscribed or circumscribed polygon and the circle is smaller than every measure, etc. It is worth the effort to make this rigorous. Let a figure expressed in brass be added, like the one published in the <var>Acts</var> of Leipzig.<a name="4" href="#note4"><sup>4</sup></a> Let there also be added a similar quadrature of the hyperbola.
               
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Michelangelo Ricci, <var>Geometrica exercitatio</var> (Rome: Tinassi, 1666). The short book consists of just 18 pages.<br />
                <a name="note2" href="#2">2.</a> This occurred on 1 September 1681.<br />
                <a name="note3" href="#3">3.</a> That is, John Wallis, <var>Mechanica: sive, De motu, tractatus geometricus. Pars prima</var> (London: William Godbid, 1670), 754-756.<br />
                <a name="note4" href="#4">4.</a> Leibniz is here presumably referring to a figure in Gottfried Wilhelm Leibniz, &quot;De vera proportione circuli ad quadratum circumscriptum in numeris rationalibus, a Gothofredo Guilielmo Leibnitio expressa,&quot; <var>Acta eruditorum</var> (1682), 41-46. English translation available <a href="/trueproportion">here</a>.<br />
                <br /><br /><br />

                <br /><br /><br />
                &#169; Lloyd Strickland 2022
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
